<template>
    <div class="perfil-avatar" @click="handleAvatarClick">
        <img :src="photoUrl" :alt="fullName" class="avatar-image clickable-avatar" />
        <input
ref="fileInput" type="file" accept="image/*" style="display: none;"
            @change="handleFileChange" />
        <button
v-if="hasPhoto" class="btn-delete-photo" title="Eliminar foto"
            @click.stop="handleDelete">
            <i class="fas fa-trash"></i>
        </button>
    </div>
</template>

<script setup>
import { defineProps, toRefs, ref } from 'vue';

const props = defineProps({
    photoUrl: {
        type: String,
        required: true
    },
    fullName: {
        type: String,
        default: ''
    },
    hasPhoto: {
        type: Boolean,
        default: false
    },
    onUpdatePhoto: {
        type: Function,
        default: null
    },
    onDeletePhoto: {
        type: Function,
        default: null
    }
});

const { photoUrl, fullName, hasPhoto, onUpdatePhoto, onDeletePhoto } = toRefs(props);
const fileInput = ref(null);

const handleAvatarClick = () => {
    if (fileInput.value) {
        fileInput.value.click();
    }
};

const handleFileChange = (event) => {
    if (onUpdatePhoto.value) {
        onUpdatePhoto.value(event);
    }
};

const handleDelete = () => {
    if (onDeletePhoto.value) {
        onDeletePhoto.value();
    }
};
</script>

<style scoped>
.perfil-avatar {
    position: relative;
    width: 120px;
    height: 120px;
    flex-shrink: 0;
}

.avatar-image {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    object-fit: cover;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    border: 3px solid #ffffff;
    outline: 1px solid #e2e8f0;
}

.clickable-avatar {
    cursor: pointer;
    transition: all 0.3s ease;
}

.clickable-avatar:hover {
    transform: scale(1.02);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.btn-delete-photo {
    position: absolute;
    bottom: -8px;
    right: -8px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #ef4444;
    color: white;
    border: 2px solid white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;
}

.btn-delete-photo:hover {
    background: #dc2626;
    transform: scale(1.1);
}
</style>
